import React from "react";
import { FiCalendar } from "react-icons/fi";

import styles from "./new.module.css";
import { getRegExp, getSentenceFromCamelCase } from "./Helpers";
import { InputProps } from "../../types/form";

type DateInputProps = InputProps & {
  leftIcon?: React.ReactNode;
};

const DateInput = ({
  checked,
  className,
  disabled,
  error,
  required,
  label,
  min,
  max,
  name,
  onChange,
  placeholder,
  reqType,
  style,
  type = "text",
  validationHandler,
  value,
  size = "medium",
  labelClassName,
  leftIcon,
}: DateInputProps) => {
  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = event.target;
    const inputValue = type === "checkbox" ? checked : value;

    onChange && onChange(name, inputValue);
  };

  const onValidationChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.currentTarget.type = "text";

    if (!validationHandler) return;

    const { value } = event.target;
    let errorMessage = "";

    if (!value && required) {
      errorMessage = `Please enter ${getSentenceFromCamelCase(name)}.`;
    } else if (value && reqType) {
      const regExp = getRegExp(reqType) as RegExp;

      if (!regExp.test(value)) {
        errorMessage = `Please enter valid ${getSentenceFromCamelCase(name)}.`;
      }
    }

    validationHandler(name, errorMessage);
  };

  return (
    <div
      className={`${styles.InputContainer} ${styles[size || ""]} ${
        error ? styles.hasError : ""
      }`}
    >
      <label htmlFor={name} className={labelClassName || styles.inputLabel}>
        {label} {required && <span className={styles.required}>&nbsp;*</span>}
      </label>

      <div className={styles.fieldShell}>
        <span className={styles.fieldIcon} aria-hidden="true">
          {leftIcon || <FiCalendar />}
        </span>

        <input
          type={type}
          name={name}
          id={name}
          value={value as string}
          checked={checked}
          placeholder={placeholder || "Select date"}
          className={`${styles.blackBorder} ${styles.modernInput} ${
            className || ""
          } ${error ? styles.borderRed : ""}`}
          required={required}
          style={style}
          disabled={disabled}
          onChange={onChangeHandler}
          onBlur={onValidationChange}
          onFocus={(e) => {
            e.currentTarget.type = "date";
          }}
          min={min}
          max={max}
        />
      </div>

      {error ? (
        <span className={`${styles.required} ${styles.textSmall}`}>
          {error}
        </span>
      ) : null}
    </div>
  );
};

export default DateInput;
